// The launcher's quick appearance sheet: the same picker as Settings → Appearance
// (components/ThemePicker.tsx), for the suite you are in.
import { Circle, Layers, Moon, MonitorSmartphone, Sun, SunMoon } from 'lucide-react'
import type { LucideIcon, LucideProps } from 'lucide-react'
import type { ComponentType } from 'react'
import type { Appearance } from '@/lib/horizon'
import { ThemePicker } from '@/components/ThemePicker'
import { Sheet } from './ui'

/** Black is a filled dot: an outlined square read as a missing icon. */
const BlackDot = (props: LucideProps) => <Circle {...props} fill="currentColor" />

type Glyph = LucideIcon | ComponentType<LucideProps>

/** The launcher's appearance button: what the look comes to now (a palette is the monitor). */
export const APPEARANCE_ICON: Record<Appearance, Glyph> = {
  auto: SunMoon,
  light: Sun,
  dark: Moon,
  black: BlackDot,
  glass: Layers,
  workspace: MonitorSmartphone,
}

export const AppearanceSheet = ({ open, onClose }: { open: boolean; onClose: () => void }) => (
  <Sheet open={open} onClose={onClose} title="Appearance">
    <ThemePicker />
  </Sheet>
)
